import { Link } from 'react-router-dom';
import { IconArrowLeft, IconChevronRight } from '@tabler/icons-react';
import { useAuth } from '../context/AuthContext';
import { LINK_SECTIONS } from './links/linkSections';
import './LinksPage.scss';

function openSupportChat() {
    if (typeof window.twc_agent_open === 'function') {
        window.twc_agent_open();
    }
}

function LinkRow({ item }) {
    const content = (
        <>
            <span className="links-page__icon" aria-hidden="true">
                <item.Icon size={18} stroke={1.5} />
            </span>
            <span className="links-page__text">
                <span className="links-page__heading">
                    <span className="links-page__label">{item.title}</span>
                    {item.note && (
                        <span className="links-page__note">{item.note}</span>
                    )}
                </span>
                {item.hint && (
                    <span className="links-page__hint">{item.hint}</span>
                )}
            </span>
            <IconChevronRight size={18} stroke={1.5} className="links-page__chevron" aria-hidden="true" />
        </>
    );

    if (item.to) {
        return (
            <Link to={item.to} className="links-page__item">
                {content}
            </Link>
        );
    }

    if (item.action === 'supportChat') {
        return (
            <button
                type="button"
                className="links-page__item"
                onClick={openSupportChat}
            >
                {content}
            </button>
        );
    }

    return (
        <a
            href={item.href}
            className="links-page__item"
            target="_blank"
            rel="noopener noreferrer"
        >
            {content}
        </a>
    );
}

export default function LinksPage() {
    const { isAuthenticated } = useAuth();
    const backTo = isAuthenticated ? '/subscriptions' : '/login';
    const backLabel = isAuthenticated ? 'К моим подпискам' : 'На страницу входа';

    return (
        <div className={`links-page${isAuthenticated ? ' links-page--with-nav' : ''}`}>
            <header className="links-page__hero">
                <h1 className="links-page__title">Информация</h1>
                <p className="links-page__subtitle">
                    Справка, контакты и документы BypassVPN
                </p>
            </header>

            <div className="links-page__sections">
                {LINK_SECTIONS.map((section) => (
                    <section
                        key={section.id}
                        className="links-page__section"
                        aria-labelledby={`links-${section.id}`}
                    >
                        <h2 id={`links-${section.id}`} className="links-page__section-title">
                            {section.title}
                        </h2>
                        <div className="links-page__card">
                            {section.items.map((item) => (
                                <div key={item.id} className="links-page__item-wrap">
                                    <LinkRow item={item} />
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </div>

            {!isAuthenticated && (
                <Link to={backTo} className="btn btn--primary btn--fixed links-page__back">
                    <IconArrowLeft size={18} stroke={1.5} />
                    {backLabel}
                </Link>
            )}
        </div>
    );
}
